import React, { useState, useRef, useEffect } from "react";
import { validarExtensionXLS } from '../../../Utils/Validations/Validations';
import ModalInformacionArchivo from './ModalInformacionArchivo';
import { CargarInforme } from '../Services/CargarInforme';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import { useToast } from '../../../Hooks/useToast';

const CargarArchivo = (props) => {
  const {setRenderizar, resetKey} = props
  const [selectedFile, setSelectedFile] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const { usuario } = useLogin();
  const fileInputRef = useRef(null);
  const addToast = useToast();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (validarExtensionXLS(file)) {
      setSelectedFile(file);
      setErrorMessage("");
    } else {
      setErrorMessage("Solo se permiten archivos con extensión .xlsx");
      setSelectedFile(null);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const file = event.dataTransfer.files[0];
    if (validarExtensionXLS(file)) {
      setSelectedFile(file);
      setErrorMessage("");
    } else {
      setErrorMessage("Solo se permiten archivos con extensión .xlsx");
      setSelectedFile(null);
    }
  };

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

   // Función para manejar la carga del archivo
   const handleUpload = async () => {
    if (selectedFile) {

      let values = {
        archivo: selectedFile,
        idUsuario: usuario.id,
        idPerfil: usuario.perfilContexto.id
      }

      const resp = await CargarInforme(values);

			if (resp) {
				if (resp.status === 200) {
          addToast({ mostrar: true, mensaje: resp.data.mensaje, titulo: 'Confirmación', tipo: resp.data.exitoso? 'Success' : 'Danger' });
          if(resp.data.exitoso){
            setError(false);
            setErrorMessage("");
            setRenderizar(true)
          }
          else{
            setError(true);
            setErrorMessage(resp.data.mensaje);
          }
				}
			}
      setSelectedFile(null);
    } else {
      alert("Por favor, selecciona un archivo antes de cargar.");
    }
  };

  useEffect(() => {
    setSelectedFile(null);
    setError(false);
    setErrorMessage("");
  }, [resetKey]);
  
  return (
    <div>
      <div className="d-flex justify-content-between align-items-start mb-4 gap-3" style={{ position: 'relative' }}>
        <span className="d-flex flex-column align-items-start">
          <h3 className="fs-3">Cargar Archivo</h3>
        </span>
        <button
          className="link link-primary gap-2 d-flex align-items-center"
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            background: 'transparent',
            border: 'none',
          }}
          onClick={handleShowModal}
        >
          <i className="ico-info-circle" style={{ fontSize: '20px' }}></i>
        </button>
      </div>

      <div
        className={`${error? "is-invalid-carga-div":""} upload-area ${dragging ? "dragging" : ""}  `}
        onDragOver={(e) => { e.preventDefault(); setDragging(true); setError(false); }}
        onDragLeave={() => setDragging(false)}
        onDrop={handleDrop}
      >
        <input
          type="file"
          id="fileUpload"
          accept=".xls,.xlsx"
          onChange={handleFileChange}
          ref={fileInputRef} 
          style={{ display: "none" }}
        />
        <label htmlFor="fileUpload">
          <div className="upload-message">
            {selectedFile ? (
              <p>Archivo seleccionado: {selectedFile.name}</p>
            ) : (
              <>
                <p><i className="ico-upload carga-archivo"></i></p>
                <p>Cargar archivo</p>
                <p>o drag&drop</p>
                <p>Archivos permitidos: XLSX. Tamaño máximo 10MB</p>
              </>
            )}
          </div>
        </label>
        <br/>
      {errorMessage &&
						<small className="message">{errorMessage}</small>
						}
      </div>
      {/* Botón para cargar el archivo */}
      <div className="d-flex justify-content-end mt-3">
        <button
          className="btn btn-primary"
          onClick={handleUpload}
          disabled={!selectedFile} // Deshabilitar el botón si no hay archivo seleccionado
        >
          Importar Archivo
        </button>
      </div>
			<ModalInformacionArchivo
				show={showModal}
				onHide={handleCloseModal}
			/>
    </div>
  );
};

export default CargarArchivo;
